import { render } from "./Paginador.vue?vue&type=template&id=58dea0f2&scoped=true"
import script from "./Paginador.vue?vue&type=script&lang=js"
export * from "./Paginador.vue?vue&type=script&lang=js"

import "./Paginador.vue?vue&type=style&index=0&id=58dea0f2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58dea0f2"]])

export default __exports__